<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      :table-border-top="true"
      :table-shadow="false"
      parentTable>
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SP" width="180px"></ad-campaign-select>
        <gj-select
            v-model="filter.status"
            :options="AdGroupEnum.SP.statusOptionNew"
            placeholder="状态"
        ></gj-select>
        <gj-select
          v-model="filter.strategyStatus"
          :options="AdStrategyStatusEnum.option"
          placeholder="分时策略"
        ></gj-select>
         <gj-select
          v-model="filter.automateRuleStatus"
          :options="automateRuleOption"
          placeholder="自动规则"
        ></gj-select>
        <gj-lazy-input
            v-model="filter.groupName"
            placeholder="广告组名称"
            width="120px"
        ></gj-lazy-input>
        <gj-date-picker
            v-model="filter.date"
            :clearable="false"
            type="daterange"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSpCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/groups/export" :download-params="globalParams"
          >
          <template #before>
            <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
          </template>
          </gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add"
      >新增广告组</gj-button>
      <gj-button :disabled="!selectedAllIsNot('state', AdGroupEnum.SP.status.ARCHIVE)" @click="adjustBidAddPopup"> 应用建议竞价 </gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdGroupEnum.SP.status.ARCHIVE)"
          @click="adjustBid">
        调整竞价
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdGroupEnum.SP.status.PAUSE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdGroupEnum.SP.status.ENABLE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSpCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdGroupEnum.SP.status.ENABLE, AdGroupEnum.SP.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/groups/export" :download-params="globalParams"
      >
      <template #before>
        <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
      </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSpCampaigns:addOrUpdate')"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :show-header-overflow="true"
          :show-footer-overflow="true"
          :pagination="pagination"
          show-summary  :summary-object="sumRecord"
          :scroll-y="{mode: 'wheel', oSize:10, gt: 40 }"
          :default-sort="defaultSort"
          :selectable="notEqSelectable('state', AdGroupEnum.SP.status.ARCHIVE)"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:targetingNum="{row}">
          <template v-if="row.groupTargetingType === AdGroupEnum.SP.targetingType.PRODUCT">{{row.targetingNum}}</template>
          <template v-if="row.groupTargetingType === AdGroupEnum.SP.targetingType.KEYWORD">{{row.keywordNum}}</template>
        </template>
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSpCampaigns:addOrUpdate')">
            <gj-tag
                v-if="row.state === AdGroupEnum.SP.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdGroupEnum.SP.status.ENABLE"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdGroupEnum.SP.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:groupName="{ row }">
          <div style="display: flex; align-items: center;" v-if="row.state !== AdGroupEnum.SP.status.ARCHIVE && $permission('adsSpCampaigns:addOrUpdate')">
              <gj-edit-input
                :value="row.groupName"
                :item="row"
                table-cell-edit
                :validator="groupNameValidator"
                :on-confirm="updateGroupName"
                :pop-title="'广告组名称'">
              <app-sp-ad-route-link
                  :ad-group-manager="{marketId, campaign: row, group: row, date}">
                <gj-tooltip
                    :text-line="2"
                    :content="row.groupName">
                  {{row.groupName | defaultShow}}
                </gj-tooltip>
              </app-sp-ad-route-link>
            </gj-edit-input>
            <div class="gj-cell-display-switch">
              <app-ad-route-link
                :market-id="row.marketId"
                :type="AdTypeEnum.SP"
                :campaign="row" :group="row">
                <gj-tooltip content="新标签页打开" >
                  <gj-icon iconfont="iconxinkaiyeqiandakai" style="font-size: 13px; color: #666; padding: 0 3px;" ></gj-icon>
                </gj-tooltip>
              </app-ad-route-link>
            </div>
          </div>
          <template v-else>
            <gj-tooltip
                :text-line="2"
                :content="row.groupName">
              {{row.groupName | defaultShow}}
            </gj-tooltip>
          </template>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sp-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:defaultBid="{ row }">
          {{ row.defaultBid | amount | defaultShow(row.currencySymbol) }}
          <AdEditBid
            :value="row"
            :isEdit="row.state !== AdGroupEnum.SP.status.ARCHIVE && $permission('adsSpCampaigns:addOrUpdate')"
            :currencySymbol="row.currencySymbol"
            :updateValue="updateBid">
          </AdEditBid>
        </template>
          <!-- 建议竞价 -->
        <!-- <template v-slot:suggestBid="{ row }">
          <div v-if="row.groupTargetingType !== 2">-</div>
          <div v-else class="bid-refresh" style="color: #0046f0;">
              <i class="el-icon-refresh" v-if="!row.refresh" @click="bidRefresh(row)" style="cursor: pointer;"></i>
              <i class="el-icon-loading" v-else-if="row.refresh == 1"></i>
              <div v-else-if="row.refresh == 2">
                <div>{{ row.recommended  | defaultShow(row.currencySymbol)}}</div>
                <div style="color: #333">
                  {{ row.rangeStart | defaultShow(row.currencySymbol)}} ~ 
                  {{ row.rangeEnd | defaultShow(row.currencySymbol)}}
                </div>
              </div>
              <div style="color: #999;" v-else-if="row.refresh == 3">暂无建议</div>
          </div>
        </template> -->
        <template v-slot:strategyStatus="{ row }">
        {{AdStrategyStatusEnum.option[row.strategyStatus].text || row.strategyStatus}}
          <div class="gj-cell-display-switch"  v-if="row.strategyStatus === 0 || row.strategyStatus === 1">
            <gj-tooltip content="编辑">
              <i class="el-icon-edit color999" @click="timeAdjust(row)"></i>
            </gj-tooltip>
            <gj-tooltip content="移除">
              <i class="iconfont iconshanchu size13 color999" style="margin-left: 10px;" @click="deleteEvent(row)"></i>
            </gj-tooltip>
          </div>
          <div class="gj-cell-display-switch"  v-if="row.strategyStatus === 2">
                <gj-button type="text" @click="timeAdjust(row)" >去添加</gj-button>
          </div>
        </template>
        <template v-slot:ruleStatus="{index, row }">
           <template v-if="row.ruleStatus === 'archived'">
              <span style="marginRight: 6px;">未添加</span>
              <div class="gj-cell-display-switch" v-if="row.ruleStatus === 'archived'">
                  <gj-button type="text" @click="handleAdd(row)" >去添加</gj-button>
              </div>
           </template>
           <template v-else>
              <el-popover @show="handlePop(index)" placement="top" trigger="click">
                <template slot="reference">
                  <div  style="color: #1F6EEF"  @click="handleRule(row)">{{row.ruleNum | defaultShow}}</div>
                </template>
                 <autoRule  v-if="index === autoRuleindex"
                   :adEntry="true"
                  :autoRuleData="autoRuleData"  :row="{marketId: row.marketId, objectId: row.groupId, objectType: 'group',campaignId: row.campaignId, objectName: row.groupName, adType: 'sp', campaignName: row.groupName}" :index="index" :ref="`autoRuleRef${index}`" @update="ruleUpdate"></autoRule>
              </el-popover>

           </template>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              v-if="row.state === AdGroupEnum.SP.status.ARCHIVE || !$permission('adsStrategyObject:add')"
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
          <gj-button-group v-else type="dropdown-op">
            <gj-button type="text" v-if="false" @click="viewAdjustLog(row)">调价日志</gj-button>
              <gj-button type="text" @click="viewLog(row)">操作日志</gj-button>
          </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin, adDefaultSortMixin, adAdvancedFilteringMixin,
    currencySymbolMixin,
    inCampaignMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin, resizeMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {queryMixin, responseMixin, selectionMixin} from "@/minxins";
  import {AdGroupEnum, AdStrategyStatusEnum, AdTypeEnum, AdLog} from "../../../common/enum";
  import AppAdjustBidModal from "../../../common/modal/adjust/adjust-bid-modal";
  import AppAddSpAdGroup from "../../common/modal/add/group/add-ad-group";
  import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
  import {subDays} from 'date-fns';
  import {
    addAdsAdjustStrategy,
    updateAdsAdjustStrategyObject,
    updateSpAdGroup,
    getAdsSpGroupSuggestedBid,
    updateAdsSpGroupsNew,
    SP,
    batchUpdateStrategyObject,
    deleteAdsAdjustStrategyTpl,
  } from "@/api/ad";
  import {adStore} from "../../../common/store";
  import {convertToDate} from "@/utils/date.util";
  import {LOG_OP_TYPE} from "../../../common/options";
  import AppAdLogModal from "../../../common/modal/log/ad-log-new-modal";
  import AppSpAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import {OpEnum} from "@/utils/options";
  import AppAdTimeAdjustStrategyOpModal from "../../../strategy/time-adjust/modal/strategy-op/time-adjust-strategy-op-modal";
  import {AdStrategyEnum} from "../../../strategy/common/enum";
  import AppStrategyAdjustLogModal from "./modal/strategy-adjust-log-modal";
  import AppAdRouteLink from "modules/ad/common/components/app-ad-route-link.vue";
  import autoRule from '@/views/modules/ad/ad-automate/application/auto-rule.vue';
  import AdEditBid from "@/views/modules/ad/common/components/ad-edit-bid.vue";
  import {getResumeConditionInfo, deleteStrategy} from '../../const'

  export default {
    name: "app-sp-ad-group",
    components: {AppSpAdRouteLink, AdCampaignSelect, AppAdRouteLink, AdEditBid, autoRule},
    mixins: [
      inMarketMixin, inPortfolioMixin, resizeMixin,
      inCampaignMixin, tableNameMixin, initDateMixin,
      selectionMixin, adBaseDataMixin, responseMixin,
      queryMixin, currencySymbolMixin, adDefaultSortMixin, adAdvancedFilteringMixin
    ],
    inject: ['getCornerMark', 'removeTab', 'getNavTabs'],
    created() {
      this.columns = [
        adFields.status,
        adFields.groupName,
        {...adFields.servingStatus, options: AdGroupEnum.SP.servingStatusOption},
        {...adFields.strategyStatus, field: 'slot:strategyStatus', options: AdStrategyStatusEnum.option},
        {...adFields.ruleStatus, field: 'slot:ruleStatus', default: true },
        {...adFields.groupTargetType, options: AdGroupEnum.SP.targetingTypeOption},
        adFields.productNum,
        {...adFields.targetNum, field: 'slot:targetingNum'},
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        // adFields.suggestBid,
        {...adFields.bid, field: 'slot:defaultBid'},
        adFields.originalBid,
        // adFields.creationDate,
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        // adFields.orderProductSales,
        adFields.acos,
        // adFields.acoas,
        // adFields.asoas,
        adFields.roas,
        {...adFields.op, width: '110px'},
      ].filter(e => e !== null);
    },
    data() {
      return {
        AdTypeEnum,
        helpName:'spadmanager',
        lastUpdatedDate: "",
        countryName: '',
        campaignIds: [],
        sumRecord: {},
        tableData: [],
        columns: [],
        loading: false,
        AdGroupEnum: AdGroupEnum,
        AdStrategyStatusEnum: AdStrategyStatusEnum,
        // filter
        filter: {
          timeStamp:null,
          status: AdGroupEnum.SP.statusNew.ENABLE_PAUSE,
          strategyStatus: null,
          automateRuleStatus: null,
          groupName: null,
          extendSearch: null,
          date: [subDays(new Date(), 6), new Date()],
        },
        // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
        filterStoragekey: 'app-sp-ad-group',
        notStorage: true,
        autoRuleData: [],
        autoRuleindex: null,
        automateRuleOption:[
            {id: 'enabled', text: '已添加'},
            {id: 'archived', text: '未添加'}
        ]
      }
    },
    watch:{
      $route:{
        handler(){
          if(this.$route.query.timeStamp!=this.filter.timeStamp){
            this.$gjQueryInit()
            this.$gjNoticeQuery()
          }
        },
        immediate: true,
      }
    },
    activated() {
       this.getTablePage();
    },
    methods: {
      // 广告组修改
      async groupsEdit(param) {
        const params = {
          marketId: this.marketId,
          params: param
        }
        try {
          const { data, msg, isError} = await SP.groupsEdit(params);
          this.$gjMessage[isError ? 'error' : 'success'](msg);
          this.clearCheckboxRow();
          data && data.forEach(item => {
            let element = this.tableData.find(e => e.groupId === item.groupId);
            Object.assign(element, item);
          });
        } catch (error) {
          console.log(error)
        }
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          filter: {
            timeStamp: this.$route.query.timeStamp,
            status: AdGroupEnum.SP.statusNew.ENABLE_PAUSE,
            groupName: this.$route.query.keyword||null,
            strategyStatus: null,
            automateRuleStatus: null,
            extendSearch: null,
            date: this.initDate || [subDays(new Date(), 6), new Date()]
          },
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) return false;
        this.getCornerMark();
        this.getTablePage();
      },
      async getTablePage() {
        this.loading = true;
        // 处理广告活动
        let campaignIds = this.campaignIds || [];
        this.campaignId && (campaignIds = [ this.campaignId ]);
        // 构造查询参数
        const params = {
          model: {
            campaignIds,
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            groupName: this.filter.groupName,
            extendSearch: this.filter.extendSearch,
            states: this.filter.status ? JSON.parse(this.filter.status) : null,
            strategyStatus: defaultVal(this.filter.strategyStatus, null),
            startDate: convertToDate(this.filter.date[0]),
            endDate: convertToDate(this.filter.date[1]),
            ruleStatus: this.filter.automateRuleStatus,
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        // 查询
        try {
          let { data } = await SP.groupsPage(params);
          this.sumRecord = data.sumRecord;
          this.lastUpdatedDate = data.lastUpdatedDate;
          this.countryName = data.countryName;
          this.tableData = this.currencySymbolMixin(data.records, adStore.SP.currencySymbol);
          this.tableData = this.tableData.map(e => ({
            ...e,
            refresh: null,
            rangeEnd: null,
            rangeStart: null,
            recommended: null,
          }))
          this.pagination = this.getPagination(data);
        } catch (error) {
          // console.log(error)
        } finally {
          this.loading = false;
        }
      },
      // 更新竞价
      async updateBid(val, row) {
        const params = [{
          groupId: row.groupId,
          adjustmentType: 0,
          adjustmentValue: val
        }]
        await this.groupsEdit(params).then(() => {
            this.$gjResetPage();
          });
      },
      // 竞价刷新
      async bidRefresh(row) {
        let params = {
          marketId: this.marketId,
          groupId: row.groupId,
        }
        this.$set(row, "refresh", 1)
        try {
          let { data } = await getAdsSpGroupSuggestedBid(params)
          this.$set(row, "refresh", 2)
          this.$set(row, "rangeEnd", data.suggestedBid.rangeEnd)
          this.$set(row, "rangeStart", data.suggestedBid.rangeStart)
          this.$set(row, "recommended", data.suggestedBid.suggested)
        } catch (error) {
          console.log(error);
          this.$set(row, "refresh", null)
        }
      },
      // 设置建议竞价弹窗
      adjustBidAddPopup() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            content: `请确认将选择的<span style="color: red;font-weight: bold;">${this.selectedRows.length}</span>个广告组竞价调整到建议竞价，更改时只对有建议竞价的对象进行操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              this.adjustBidQuick()
              modal.$gjDestroy()
            }
          }
        });
      },
      // 设置建议竞价
      adjustBidQuick() {
        // 判断是否包含未获取建议竞价的项
        let condition = false
        for (const e of this.selectedRows) {
          if (!e.recommended) {
            condition = true
          }
        }
        if (condition) {
          this.$gjMessage.error('请先获取建议竞价')
          for (const row of this.selectedRows) {
            this.bidRefresh(row)
          }
          return false
        }
        this.loading = true
        SP.groupsEdit({
          marketId: this.marketId,
          params: this.selectedRows.map(e => ({
            state: e.state,
            groupId: e.groupId,
            adjustmentType: 0,
            adjustmentValue: e.recommended
          })),
        })
          .then(({ msg, isError }) => {
            this.$gjMessage[isError ? 'error' : 'success'](msg);
            this.$gjResetPage();
          })
          .complete(() => this.loading = false);
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      groupNameValidator(name) {
        return isMeaningful(name);
      },
      async updateGroupName(name, row, closeEditor, closeLoading) {
        const params = [{
          groupId: row.groupId,
          groupName: name
        }]
        try {
          await this.groupsEdit(params);
          closeEditor();
        } catch (error) {
          
        } finally {
          closeLoading();
        }
        // updateSpAdGroup({
        //   marketId: this.marketId,
        //   groupIds: [row.groupId],
        //   groupName: name,
        // })
        //   .then(() => {
        //     this.$gjMessage.success('操作成功');
        //     closeEditor();
        //     this.$gjResetPage();
        //   })
        //   .complete(() => closeLoading());
      },
      add() {
        this.$gjCreate(AppAddSpAdGroup, {
          props: {
            marketId: this.marketId,
            campaign: this.campaign
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      // 修改竞价
      adjustBid() {
        const modal = this.$gjCreate(AppAdjustBidModal, {
          props: {
            currencySymbol: adStore.SP.currencySymbol
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = this.selectedRows.map(e => ({
                groupId: e.groupId,
                adjustmentType: modal.form.bid.key,
                adjustmentValue: modal.form.bid.value,
              }))
              try {
                await this.groupsEdit(params);
                modal.$gjDestroy()
              } catch (error) {
                
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个广告组，确认启用？` : `确认启用广告组[${rows[0].groupName || ''}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = rows.map(e => ({
                groupId: e.groupId,
                state: AdGroupEnum.SP.status.ENABLE
              }))
              try {
                await this.groupsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个广告组，确认停用？`: `确认停用广告组[${rows[0].groupName || ''}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = rows.map(e => ({
                groupId: e.groupId,
                state: AdGroupEnum.SP.status.PAUSE
              }))
              try {
                await this.groupsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = this.selectedRows.map(e => ({
                groupId: e.groupId,
                state: AdGroupEnum.SP.status.ARCHIVE
              }))
              try {
                await this.groupsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      viewLog(row) {
        let campaignId = this.campaignId || row?.campaignId;
        let groupId = this.groupId || row?.groupId;
        let objectName = row?.groupName;
        this.$gjCreate(AppAdLogModal, {
          props: {
            campaignId,
            objectName,
            marketId: this.marketId,
            adType: 'SP',
            objectType: AdLog().objCell.group,
            name: isMeaningful(row) ? row.groupName : '',
          }
        });
        // this.$gjCreate(AppAdLogModal, {
        //   props: {
        //     marketId: this.marketId,
        //     campaignId: this.campaignId,
        //     name: isMeaningful(row) ? row.groupName : '',
        //     opId: isMeaningful(row) ? row.groupId : null,
        //     adType: LOG_OP_TYPE.SP,
        //     object: LOG_OP_TYPE.SP.GROUP
        //   }
        // });
      },
      // 广告策略
      timeAdjust(row) {
        const modal = this.$gjCreate(AppAdTimeAdjustStrategyOpModal, {
          props: {
            title: `<span>分时策略</span><span class="modal-secondary-title">(${row.groupName})</span>`,
            opType: OpEnum.type.USE,
            item: row,
            objectId: row.objectId,
            strategyType: 1,// 1：广告组、关键词、商品投放、投放组， 2：广告位， 3：广告活动
          },
          on: {
              updated: () => {
                this.$gjMessage.success('操作成功');
                this.$gjResetPage();
                modal.$gjDestroy();
              },
              useStrategy: ({params, status, templateId, callback, resumeDTO}) => {
              modal.confirmLoading = true;
              let useParams;
              Promise.resolve(row.strategyStatus)
                  .then((strategyStatus) => {
                      if (strategyStatus === AdStrategyStatusEnum.NO_ADD) {
                        useParams = {
                          resumeDTO,
                          id: row.objectId,
                          adsStrategyTemplate: params,
                          marketId: row.marketId,
                          bid: row.defaultBid,
                          status,
                          templateId,
                          campaignId: row.campaignId,
                          campaignName: row.campaignName,
                          groupId: row.groupId,
                          groupName: row.groupName,
                          objectId: row.groupId,
                          objectName: row.groupName,
                          objectType: AdStrategyEnum.objectType.GROUP
                        }
                          return addAdsAdjustStrategy(useParams)
                      } else {
                        useParams = [{
                          ...params,
                          marketId: row.marketId,
                          objectPid: row.objectId,
                          objectStatus: status,
                          templatePId:templateId,
                        }]
                          return batchUpdateStrategyObject(useParams)
                      }
                })
                  .then((res) => {
                    if (callback) {
                      callback(res);
                    }
                  })
                .complete(() => modal.confirmLoading = false);
            },
            viewLog: (item) => {
              this.viewAdjustLog(item);
            }
          }
        })
      },
      viewAdjustLog(row) {
        this.$gjCreate(AppStrategyAdjustLogModal, {
          props: {
            item: row,
          }
        })
      },
        // 移除，二次确认
    deleteEvent(row) {
      deleteStrategy(this, row);
      // const modal = this.$gjCreate('gj-info-modal', {
      //   props: {
      //     title: '移除确认',
      //     content: `确定要移除分时策略吗？请谨慎操作！`
      //   },
      //   on: {
      //     cancel: () => modal.$gjDestroy(),
      //     confirm: () => {
      //       modal.confirmLoading = true;
      //        getResumeConditionInfo(row.objectId, row, (res) => {
      //           modal.confirmLoading = false
      //           if (res === 'success') {
      //             this.$gjMessage.success('移除成功');
      //             this.$gjResetPage();
      //             modal.$gjDestroy();
      //           }else {
      //             this.$gjMessage.success('移除失败，请稍后重试');
      //           }

      //         })
      //     }
      //   }
      // });

    },
    // 查询自动规则详情
    handlePop(index) {
      // todo 这个地方存在一个异常的BUG，但是目前没找到原因只能暂时这样解决
      this.autoRuleindex = index;
      this.$nextTick(() => {
        this.$refs[`autoRuleRef${index}`].loading = true
        this.$refs[`autoRuleRef${index}`].query().then(res => {
          this.autoRuleData = res;
        }).finally(() => {
          this.$refs[`autoRuleRef${index}`].loading = false
        });
      })

    },
    handleRouter(callback, name) {
      const tabs = this.getNavTabs();
        if (tabs.some(item => item.name === name)) {
            this.removeTab(name);
            callback();
        } else {
            callback();
        }
    },
    //添加自动规则
    handleAdd(row) {
         const extra = [{
            marketId: row.marketId,
            adsType: 'sp',
            campaignId: row.campaignId,
            applyObjectId: row.groupId,
            applyObjectName: row.groupName,
            applyObjectAdsType: 'group',
        }]
        this.handleRouter(() => {
          this.$router.push({path: `/ad/add-rule-template`, query: {
              type: 'add',
              belong: 'rule',
              sourceRoute: this.$route.path,
              extra: JSON.stringify(extra)
          }})
        }, '新增自动模板规则')
    },
    handleRule(row) {
      console.log(row);
    },
       // 规则pop更新列表数据
    ruleUpdate(arr, index) {
         this.$gjQuery()
    }
  },

}
</script>

<style scoped>

</style>
